'use client';

import css from './sections-navigation.module.scss';
import React from "react";
import useSectionsNavigation from "@/parts/SectionsNavigation/useSectionsNavigation";

interface ISectionNavigationProps {
    title: string;
    id: string;
}

interface ISectionsNavigationProps {
    sections: ISectionNavigationProps[];
    children: React.ReactNode;
}

export const SectionsNavigation = ({ sections, children }: ISectionsNavigationProps) => {
    const { activeTab, setActiveTab, scrollToCategory, updateMainUrl } = useSectionsNavigation({ sections });

    const sectionsIds = sections.map((section) => section.id);

    return (<div className='relative'>
        <div id="customizationList-wrapper" className='sticky top-0 bg-white z-[50]'>
            <div className="sticky_nav__wrapper" id="customizationList-stickyHeader">
                <nav className={css['sections-navigation']}>
                    {
                        React.Children.map(children, (child, idx) => {
                            return <a
                                key={`${sectionsIds[idx]}-nav-button`}
                                href={""}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setActiveTab(sectionsIds[idx]);
                                    scrollToCategory(sectionsIds[idx]);
                                    updateMainUrl(sectionsIds[idx]);
                                }}
                                className={activeTab === sectionsIds[idx] ? css['a__active'] : css['a__inactive']}
                            >
                                {sections[idx].title}
                            </a>
                        })
                    }
                </nav>
            </div>
        </div>
        {React.Children.map(children, (child, idx) => (
            <div id={`section-${sectionsIds[idx]}`}>
                {child}
            </div>
        ))}
    </div>);
}
